import { EditorContent, mergeAttributes, useEditor } from '@tiptap/react';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import StarterKit from '@tiptap/starter-kit';
import RichEditorBase from './RichEditorBase.jsx';

const RichTextEditor = ({
    initialValue,
    onChange,
    className,
    compactMenu,
}) => {
    return (
        <RichEditorBase
            initialValue={initialValue}
            onChange={onChange}
            className={className}
            showToolbar={true}
            compactMenu={compactMenu}
        />
    );
};

export default RichTextEditor;
